'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesHoldingsLists.css');

var TargetDateSeriesHoldingsLists = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesHoldingsLists, _Component);

  function TargetDateSeriesHoldingsLists(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesHoldingsLists);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesHoldingsLists.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesHoldingsLists)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateSeriesHoldingsLists, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iyvConfigCategories = _props.iyvConfigCategories,
          targetDateSeries = _props.targetDateSeries;


      return _react2.default.createElement(
        'div',
        { styleName: 'holding-lists' },
        iyvConfigCategories.map(function (e, i) {
          if (!e.fld) {
            return null;
          }
          var holdingsCount = targetDateSeries.holdings[e.fld].count;
          var holdingsList = targetDateSeries.holdings[e.fld].list;
          return holdingsCount > 0 ? _react2.default.createElement(
            'div',
            { styleName: 'holding-list', key: 'holding-list-' + i },
            _react2.default.createElement(
              'div',
              { styleName: 'holding-list-icn-title-flex' },
              e.icon ? _react2.default.createElement('img', {
                src: e.icon,
                alt: e.lbl,
                styleName: 'holding-list-icn'
              }) : _react2.default.createElement('div', { styleName: 'holding-list-no-icn' }),
              _react2.default.createElement(
                'div',
                { styleName: 'holding-list-title' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'holding-list-title-label' },
                  'Top ',
                  holdingsCount,
                  ' holdings'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  e.lbl
                )
              )
            ),
            _react2.default.createElement(
              'ol',
              null,
              holdingsList.map(function (_e, _i) {
                return _react2.default.createElement(
                  'li',
                  { key: 'holding-list-item-' + _i },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-list-item' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'holding-list-item-title' },
                      _e.standard_name
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _format2.default.perc(_e.long_weight)
                    )
                  )
                );
              })
            )
          ) : null;
        })
      );
    }
  }]);
  return TargetDateSeriesHoldingsLists;
}(_react.Component), _class2.propTypes = {
  // the config for this set of IYV categories
  iyvConfigCategories: _react.PropTypes.array.isRequired,
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesHoldingsLists;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesHoldingsLists/TargetDateSeriesHoldingsLists.js
// module id = 1450
// module chunks = 0